
/* injects from baggage-loader */

'use strict';
import $ from 'jquery';
import TypeIt from 'typeit';

export default class InterviewBallonController {
    constructor($log, $rootScope, $element) {
        'ngInject';
        this.$log = $log;
        this.$element = $element;
        this.player =  new Audio(this.audio);
        
        $rootScope.$on('open:ballon', (event, data) => {
            data.key === this.key ? this.initializeBallon(this.$element) : false
        });

        $rootScope.$on('interview:close', () => {
            this.player.pause();
        });

        $rootScope.$on('audio:off', () => {
            this.mute();
        });

        $rootScope.$on('audio:on', () => {
            this.unmute();
        });
    }  

    initializeBallon(element){
        let text = $(element).find('.interview-ballon-text');
        
        text.removeClass('ng-hide');
        this.initializeAudio();

        let typeit = new TypeIt(text, {
            speed: 45,
            startDelay: 500
        });

        return typeit;
    }

    initializeAudio(){
        this.player =  new Audio(this.audio);
        this.playing = true;
        this.player.onended = () => {
            this.playing = false;
        }
        this.player.play();
        if(this.sound === "on")
            this.player.volume = 1;
        else
            this.player.volume = 0;
    }

    mute(){
        this.player.volume = 0;
    }

    unmute(){
        this.player.volume = 1;
    }

    finish(){
        return !this.playing ? this.afterClose() : false
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/interview-ballon/interview-ballon.controller.js